<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->

    <main>
      <!--  =========== Start:: Filter Form =========== -->

      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>

        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>

        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.client-name')"
                v-model="filterOptions.client_name"
              />

              <!-- <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.salon_name')"
                v-model="filterOptions.salonName"
              /> -->

              <!-- Start:: Start Date Input -->
              <base-picker-input
                col="4"
                type="date"
                :placeholder="$t('PLACEHOLDERS.startDate')"
                v-model.trim="filterOptions.from_date"
              />
              <!-- End:: Start Date Input -->

              <!-- Start:: End Date Input -->
              <base-picker-input
                col="4"
                type="date"
                :placeholder="$t('PLACEHOLDERS.endDate')"
                v-model.trim="filterOptions.to_date"
              />
              <!-- End:: End Date Input -->
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>

              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->

      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>
            {{ $t("SIDENAV.financialreports.title") }}
          </h5>

          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>

        <div class="title_route_wrapper">
          <base-button
            class="mt-0 pdf_btn"
            styleType="solid_btn"
            :btnText="$t('BUTTONS.downloadPdf')"
            @fireClick="downloadPdf"
            :disabled="pdfDownloadBtnIsLoading"
          >
            <template v-slot:btn_icon>
              <i class="fal fa-file-pdf"></i>
            </template>
          </base-button>
          <base-button
            class="mt-0 excel_btn"
            styleType="solid_btn"
            :btnText="$t('BUTTONS.downloadExcel')"
            @fireClick="downloadExcel"
            :disabled="excelDownloadBtnIsLoading"
          >
            <template v-slot:btn_icon>
              <i class="fal fa-file-excel"></i>
            </template>
          </base-button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- @click:row="goToOrderDetails" -->
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <template v-slot:[`item.serial`]="{ item, index }">
          <div class="table_image_wrapper">
            <p class="text-danger" v-if="!item.id">
              {{ $t("TABLES.noData") }}
            </p>

            <p v-else>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.coupon_discount_value_provider`]="{ item }">
          <div class="table_image_wrapper">
            <p class="text-danger" v-if="!item.coupon_discount_value_provider">
              -
            </p>

            <p v-else>
              {{ item.coupon_discount_value_provider }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.coupon_discount_value_admin`]="{ item }">
          <div class="table_image_wrapper">
            <p class="text-danger" v-if="!item.coupon_discount_value_admin">
              -
            </p>

            <p v-else>
              {{ item.coupon_discount_value_admin }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.id`]="{ item }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.id">-</p>
          <a
            v-else
            @click="showItem(item)"
            style="
              text-decoration: underline;
              cursor: pointer;
              color: var(--main_theme_clr);
            "
          >
            {{ item.id }}
          </a>
        </template>

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <!--  v-if="permissions.show" -->

            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>
          </div>
        </template>
        <!-- End:: Actions -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
      <!-- ==== Start:: Overall_statistics Addresses ==== -->
      <div class="table_content">
        <div class="table_title_wrapper">
          <div class="title_text_wrapper">
            <!-- <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5> -->
          </div>
        </div>
        <v-simple-table class="stat-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">
                  {{ $t("PLACEHOLDERS.total_provider_profit") }}
                </th>

                <th class="text-center">
                  {{ $t("PLACEHOLDERS.totalTaxValue") }}
                </th>

                <th class="text-center">
                  {{ $t("PLACEHOLDERS.total_profits") }}
                </th>

                <th class="text-center">
                  {{ $t("PLACEHOLDERS.total_commission_without_tax") }}
                </th>

                <th class="text-center">
                  {{ $t("PLACEHOLDERS.totalTaxCommission") }}
                </th>

                <th class="text-center">
                  {{ $t("PLACEHOLDERS.totalFinishedOrder") }}
                </th>
              </tr>
            </thead>

            <tbody>
              <template>
                <tr class="text-center all-stat">
                  <td>{{ total_provider_profit }}</td>

                  <td>{{ totalTaxValue }}</td>

                  <td>{{ totalCommission }}</td>

                  <td>{{ commission_without_tax }}</td>

                  <td>{{ totalTaxCommission }}</td>

                  <td>{{ total }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <!-- ==== End:: Overall_statistics Addresses ==== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->

    <!-- Start:: Generate PDF Template Content -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :filename="$t('PLACEHOLDERS.financial_reports')"
      :pdf-quality="2"
      pdf-format="a3"
      :manual-pagination="false"
      :paginate-elements-by-height="1400"
      pdf-content-width="100%"
      @progress="bdfDownloadBtnIsLoading = true"
      @hasGenerated="$message.success($t('MESSAGES.generatedSuccessfully'))"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="pdf_file_content p-3">
          <h3 class="file_title">
            {{ $t("SIDENAV.financialreports.title") }}
          </h3>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th v-for="header in tableHeaders" :key="header.value">
                    <span>{{ header.text }}</span>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(row, index) in tableRows" :key="row.id">
                  <td>
                    {{ row.id ? index + 1 : "-" }}
                  </td>

                  <td>
                    {{ row.id ? row.id : "-" }}
                  </td>

                  <td>
                    {{ row.created_at ? row.created_at : "-" }}
                  </td>

                  <td>
                    {{ row.user_name ? row.user_name : "-" }}
                  </td>

                  <td>
                    {{ row.salon_name ? row.salon_name : "-" }}
                  </td>

                  <td>
                    {{ row.provider_profit ? row.provider_profit : "-" }}
                  </td>

                  <td>
                    {{ row.tax ? row.tax : "-" }}
                  </td>

                  <td>
                    {{ row.commission ? row.commission : "-" }}
                  </td>
                  <td>
                    {{ row.commission_tax ? row.commission_tax : "-" }}
                  </td>
                  <td>
                    {{
                      row.commission_without_tax
                        ? row.commission_without_tax
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      row.coupon_discount_value
                        ? row.coupon_discount_value
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      row.coupon_discount_value_provider
                        ? row.coupon_discount_value_provider
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      row.coupon_discount_value_admin
                        ? row.coupon_discount_value_admin
                        : "-"
                    }}
                  </td>
                  <td>
                    {{ row.total ? row.total : "-" }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <!-- ==== Start:: Overall_statistics Addresses ==== -->
          <div class="table_content">
            <div class="table_title_wrapper">
              <div class="title_text_wrapper"></div>
            </div>
            <v-simple-table class="stat-table mt-5">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.total_provider_profit") }}
                    </th>

                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.totalTaxValue") }}
                    </th>

                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.total_profits") }}
                    </th>

                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.total_commission_without_tax") }}
                    </th>

                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.totalTaxCommission") }}
                    </th>

                    <th class="text-center">
                      {{ $t("PLACEHOLDERS.totalFinishedOrder") }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <template>
                    <tr class="text-center all-stat">
                      <td>{{ total_provider_profit }}</td>

                      <td>{{ totalTaxValue }}</td>

                      <td>{{ totalCommission }}</td>

                      <td>{{ commission_without_tax }}</td>

                      <td>{{ totalTaxCommission }}</td>

                      <td>{{ total }}</td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <!-- ==== End:: Overall_statistics Addresses ==== -->
        </div>
      </section>
    </vue-html2pdf>
    <!-- End:: Generate PDF Template Content -->
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import { mapGetters } from "vuex";

export default {
  name: "AllFinancialReports",

  components: {
    VueHtml2pdf,
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    UserTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.designer_filter"),
          value: "designer",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.service_requester"),
          value: "client",
        },
      ];
    },
  },

  data() {
    return {
      statistic: {
        count: null,
        providerRevenu: null,
        appRevenu: null,
        totalVat: null,
      },

      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      pdfDownloadBtnIsLoading: false,
      excelDownloadBtnIsLoading: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        salonName: null,
        client_name: null,
        from_date: null,
        to_date: null,
      },
      allproviders: [],
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "serial",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.orderNum"),
          value: "id",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("TABLES.Orders.orderDate"),
          value: "created_at",
          sortable: false,
          align: "center",
          width: "120px",
        },
        {
          text: this.$t("PLACEHOLDERS.client-name"),
          value: "user_name",
          sortable: false,
          align: "center",
        },
        // {
        //   text: this.$t("PLACEHOLDERS.salon_name"),
        //   value: "salon_name",
        //   sortable: false,
        //   align: "center",
        // },
        {
          text: this.$t("PLACEHOLDERS.provider_profit"),
          value: "provider_profit",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.tax"),
          value: "tax",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.total_profits"),
          value: "commission",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.commission_tax"),
          value: "commission_tax",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.commission_without_tax"),
          value: "commission_without_tax",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.coupon_discount_value"),
          value: "coupon_discount_value",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.coupon_discount_value_provider"),
          value: "coupon_discount_value_provider",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.coupon_discount_value_admin"),
          value: "coupon_discount_value_admin",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.order_total"),
          value: "total",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data
      // Start:: Dialogs Control Data
      dialogImage: false,
      selectedItemImage: null,
      dialogDescription: false,
      selectedDescriptionTextToShow: "",
      dialogPdf: false,
      itemToPdf: null,
      dialogExcel: false,
      itemToExcel: null,
      // End:: Dialogs Control Data

      // Start:: Page Permissions
      permissions: null,
      // Start:: Page Permissions
      total_provider_profit: null,
      totalTaxValue: null,
      commission_without_tax: null,
      totalCommission: null,
      totalTaxCommission: null,
      total: null,
      total_orders: null,
      total_admin_profit: null,
      total_orders_duration: null,
      total_orders_with_tax: null,

      pdf: null,
      excel_report: null,
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    goToOrderDetails(item) {
      this.$router.push(`/orders/show/${item.id}`);
    },
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/financial-reports/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    async resetFilter() {
      //   this.filterOptions.provider_name = null;
      this.filterOptions.client_name = null;
      this.filterOptions.salonName = null;
      this.filterOptions.from_date = null;
      this.filterOptions.to_date = null;
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/financial-reports/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "financial-reports",
          params: {
            page: this.paginations.current_page,
            clientName: this.filterOptions.client_name,
            salonName: this.filterOptions.salonName,
            from: this.filterOptions.from_date,
            to: this.filterOptions.to_date,
          },
        });
        console.log("financial", res);

        this.loading = false;
        this.tableRows = res.data.data.data;
        this.excel_report = res.data.data.total.excel;

        this.total_provider_profit = res.data.data.total.provider_profit;
        this.totalTaxValue = res.data.data.total.tax;
        this.commission_without_tax =
          res.data.data.total.commission_without_tax;
        this.totalCommission = res.data.data.total.commission;
        this.totalTaxCommission = res.data.data.total.commission_tax;
        this.total = res.data.data.total.total;

        this.paginations.last_page = res.data.data.meta.last_page;
        this.paginations.items_per_page = res.data.data.meta.per_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows

    // Start:: Handling Download Files
    async downloadPdf() {
      await this.$refs.html2Pdf.generatePdf();
      this.pdfDownloadBtnIsLoading = false;
    },

    async downloadExcel() {
      await window.open(this.excel_report, "_blank");
    },

    // End:: Handling Download Files

    // ==================== Start:: Crud ====================
    // ===== Start:: Show
    showItem(item) {
      this.$router.push({ path: `/orders/show/${item.id}` });
      // this.$router.push({ path: `/orders/all`, query: { provider: item.user_applicant } });
    },
    // ===== End:: Show

    // ==================== End:: Crud ====================
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }

    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.ex-btn-s {
  color: black !important;
  font-size: 20px;
  font-weight: bold;
  text-decoration: underline !important;
}

.all-stat {
  background: var(--main_theme_clr);
}

.all-stat td {
  color: white;
  font-size: 21px !important;
  font-weight: 800;
}

.show_all_content_wrapper
  .v-data-table
  .v-data-table__wrapper
  table
  tbody
  tr:hover {
  background: var(--main_theme_clr) !important;
}

.excel {
  background: darkgreen;
  padding: 7px 18px;
  border: 1px solid darkgreen;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
}
.excel:hover {
  background: rgb(255, 255, 255);
  border-radius: 5px;
  color: darkgreen;
  cursor: pointer;
}
</style>
